module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.eot
 ** module id = 106
 ** module chunks = 1
 **/